/* =============================================================================
 * Delta Clothing — B2B "from $X" price tag on product cards
 *
 * Brand review #3 (#7): logged-in wholesale customers should see their
 * tier price next to (or below) the catalog price on collection / search
 * grids — matches what /products/<handle> already shows via the depot
 * grid. Stockmart's `snippets/price.liquid` only renders the catalog
 * price, so we enrich client-side.
 *
 * Behaviour
 *  - Anonymous visitors: noop (no customer id available).
 *  - Logged-in customers: collect every visible product card on the page
 *    (`.card-wrapper[data-product-handle]`), batch the handles into a
 *    single POST `/api/cards/prices`, then inject a small "from $X" span
 *    into each card's existing `.price` cell.
 *  - On failure (404, network, etc.): silent. Cards keep showing the
 *    catalog price unchanged.
 *
 * Backend contract (live on dash.deltaclothing.com):
 *
 *   POST /api/cards/prices
 *   Content-Type: application/json
 *   Body: { customer_id: <int|gid>, handles: ["t-shirt-bella-3001", ...] }
 *   Response: { "<handle>": { "from": 2.40, "currency": "USD" }, ... }
 *
 * Implemented in delta-clothing-new commit 8c9ee6b (ThemeApiController::
 * cardsPrices). Anonymous visitors / unresolved customers get an empty
 * {} from the server so the storefront silently keeps the catalog price.
 * The .catch below also swallows network errors for the same reason.
 *
 * Depends on window.B2B (b2b-config.js), loaded earlier.
 * =============================================================================*/
(function () {
  if (window.__dlc_card_prices_installed) return;
  window.__dlc_card_prices_installed = true;

  function customerId() {
    if (window.B2B && window.B2B.customer && window.B2B.customer.id) return window.B2B.customer.id;
    if (window.B2B && typeof window.B2B.getCustomerId === 'function') return window.B2B.getCustomerId();
    try { return (document.body && document.body.getAttribute('customer')) || ''; } catch (e) { return ''; }
  }

  function endpoint() {
    if (window.B2B && window.B2B.endpoints && window.B2B.endpoints.cardsPrices) {
      return window.B2B.endpoints.cardsPrices;
    }
    var base = (window.B2B && window.B2B.DASH_BASE) || '';
    return base + '/api/cards/prices';
  }

  function moneyFmt(n) {
    var v = parseFloat(n);
    if (isNaN(v)) v = 0;
    return '$' + v.toFixed(2);
  }

  function decorate(cards, data) {
    if (!data || typeof data !== 'object') return;
    cards.forEach(function (card) {
      var handle = card.getAttribute('data-product-handle');
      if (!handle) return;
      var entry = data[handle];
      if (!entry) return;
      var from = entry.from != null ? entry.from : entry.price;
      if (from == null) return;
      var priceEl = card.querySelector('.price');
      if (!priceEl) return;
      // Avoid double-decoration if the painter runs twice (cart/section reload).
      if (priceEl.querySelector('.card__b2b-price')) return;
      var tag = document.createElement('span');
      tag.className = 'card__b2b-price';
      tag.innerHTML = '<span class="card__b2b-price-label">from</span> ' + moneyFmt(from);
      priceEl.appendChild(tag);
    });
  }

  function paint() {
    var cid = customerId();
    if (!cid) return;
    var cards = document.querySelectorAll('.card-wrapper[data-product-handle]');
    if (!cards.length) return;
    var seen = {};
    var handles = [];
    cards.forEach(function (c) {
      var h = c.getAttribute('data-product-handle');
      if (!h || seen[h]) return;
      seen[h] = true;
      handles.push(h);
    });
    if (!handles.length) return;
    fetch(endpoint(), {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ customer_id: cid, handles: handles })
    })
      .then(function (r) {
        if (!r || !r.ok) throw new Error('cards/prices ' + (r && r.status));
        return r.json();
      })
      .then(function (data) { decorate(cards, data); })
      .catch(function () { /* silent — see CHANGES.md note for the missing endpoint */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paint, { once: true });
  } else {
    setTimeout(paint, 0);
  }

  // Theme-editor reloads + AJAX section swaps (Stockmart filter swaps the
  // grid via section rendering API). Re-paint on Shopify section load and
  // on facet form submits so newly-rendered cards pick up tier prices.
  document.addEventListener('shopify:section:load', function () { setTimeout(paint, 0); });
  document.addEventListener('facet:loaded', function () { setTimeout(paint, 0); });

  window.__dlc_card_prices = { repaint: paint };
})();
